'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifNullish = exports.isAsyncFunction = exports.isPromise = exports.upon = exports.tap = void 0;
const goodies_1 = require("./goodies");
function tap(value, callback) {
    return new goodies_1.Goodies().tap(value, callback);
}
exports.tap = tap;
function upon(value, callback) {
    return new goodies_1.Goodies().upon(value, callback);
}
exports.upon = upon;
/**
 * Determine whether the given `promise` is a Promise.
 *
 * @param {*} promise
 *
 * @returns {Boolean}
 *
 * @example
 * isPromise('no') // false
 * isPromise(new Promise(() => {})) // true
 */
function isPromise(promise) {
    return new goodies_1.Goodies().isPromise(promise);
}
exports.isPromise = isPromise;
/**
 * Determine whether the given `input` is an async function.
 *
 * @param {*} input
 *
 * @returns {Boolean}
 */
function isAsyncFunction(input) {
    return new goodies_1.Goodies().isAsyncFunction(input);
}
exports.isAsyncFunction = isAsyncFunction;
function ifNullish(input, callback) {
    return new goodies_1.Goodies().ifNullish(input, callback);
}
exports.ifNullish = ifNullish;
